import React from 'react';
import Rulebook from './Rulebook';

const GameRules = () => {
  return <Rulebook />;
};

export default GameRules;